
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
// Update your component
export class SpinnerComponent {
  @Input() show: boolean = false;
   @Input() message: string = 'Loading...'; 
  bars = new Array(8); // 8 bars for the loader
}